<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headDataI: getdata().headDataI,
			};
		},
		props: {
			showpz: {
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: [],
			},
			choosecellCode: {
				type: String,
				default: ""
			},
			type: {
				type: String,
				default: ""
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},
		created() {
		},
		methods: {
			inputblur(e) {
				this.$emit("inputblur", e)
			},
			forhover(table, colum, index) {
				this.$emit("forhover", table, colum, index)
			},
			zcsclick(e) {
				this.$emit("zcsclick", e)
			},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}){
				if (rowIndex === 0) {
					
				}
			},
			headercellstyle({
				row,
				column,
				rowIndex,
				columnIndex
			}){
				if (rowIndex === 0) {
					if (columnIndex === 0) {
						this.$nextTick(() => {
							if (document.getElementsByClassName(column.id).length !== 0) {
								document
									.getElementsByClassName(column.id)[0]
									.setAttribute('rowspan',0)
								document.getElementsByClassName(column.id)[0].style.height="40px"
							}
						});
					}else{}
				}
			},
		},
		
	}
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SalesTaxReport/index.less');
</style>
